import {
    // FILE_UPLOAD,
    CREATE_SJFSERVICES,
    RETRIEVE_SJFSERVICES,
    UPDATE_SJFSERVICES,
    DELETE_SJFSERVICES,
    RETRIEVESINGLE_SJFSERVICES,
} from "./type";
import SJFServices from "../service/sjfServices";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await SJFServices.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await SJFServices.create(data);
        dispatch({
            type: CREATE_SJFSERVICES,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await SJFServices.fetchList(data);
        dispatch({
            type: RETRIEVE_SJFSERVICES,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await SJFServices.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_SJFSERVICES,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await SJFServices.update(data);
        dispatch({
            type: UPDATE_SJFSERVICES,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await SJFServices.changeStatus(data);
//         dispatch({
//             type: UPDATE_SJFSERVICES,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await SJFServices.trash(data);
        dispatch({
            type: DELETE_SJFSERVICES,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};